import { Dayjs } from "rc-picker/node_modules/dayjs";
import { IPaginationOffsetParams, IPaginationTypeOffsetWithTotalResponse } from "./common";

export enum VoucherOfflineStatus {
  ACTIVE = "ACTIVE",
  USED = "USED",
  EXPIRED = "EXPIRED",
}

export interface IVoucherOfflineItem {
  id: string | number;
  memberCardId: string;
  issuedAt: number;
  expiredAt: number;
  campaignName: string;
  status: VoucherOfflineStatus;
}

export interface IVoucherOfflineFilterForm {
  phone: string;
  assignedDateRange?: [Dayjs, Dayjs];
}

export interface IVoucherOfflineQueryFilters {
  phone: string;
  issuedAtFrom?: number;
  issuedAtTo?: number;
}

export interface IGetVoucherOfflineParams extends IPaginationOffsetParams {
  phone: string;
  issuedAtFrom?: number;
  issuedAtTo?: number;
}

export interface IVoucherOfflineListPagination {
  offset: number;
  limit: number;
  total: number;
}

export interface IGetVoucherOfflineResponseData {
  vouchers: IVoucherOfflineItem[];
  pagination?: IPaginationTypeOffsetWithTotalResponse;
}
